import React, { Component } from 'react';
import { connect } from "react-redux";
import {
    SYNTH,
    MULTI_SYNTH,
    Z4,
    SAMPLED_INSTRUMENT,
    FM_SYNTH,
    METAL_SYNTH} from 'constants/instrument-types.js';
import {
    setContextualHelp,
    setInstrumentTypeDragging
} from 'actions/index.js';
import {ADD_SYNTH_BUTTON,
        ADD_MULTI_SYNTH_BUTTON,
        ADD_FM_SYNTH_BUTTON,
       ADD_EXTERNAL_INSTRUMENT_BUTTON} from 'constants/contextual-help.js';
import '../../Instruments.scss';

class InstrumentsView extends Component {
    constructor(props) {
        super(props);
    }

    onClickSynth() {
        this.props.sequencerEngine.addInstrumentTrack();
    }

    onClickMultiSynth() {
        this.props.sequencerEngine.addMultiSynthTrack();
    }

    onClickMultiSampler() {
        this.props.sequencerEngine.addSampledInstrumentTrack();
    }

    onClickMetalSynth() {
        this.props.sequencerEngine.addMetalSynthTrack();
    }

    onClickFMSynth() {
        this.props.sequencerEngine.addFMSynthTrack();
    }

    onClickZ4Track() {
        this.props.sequencerEngine.addZ4Track();
    }

    onClickExternalInstrument() {
        this.props.sequencerEngine.addMidiTrack();
    }

    onClickInstrumentRack() {
        this.props.sequencerEngine.addInstrumentRackTrack();
    }

    onDragStart(type) {
        if (type === undefined) {
            return;
        }
        this.props.setInstrumentTypeDragging(type);
    }

    render() {
        return (
            <div className="instruments-view">
              <InstrumentOption
                type={SAMPLED_INSTRUMENT}
               onDragStart={(type) => this.onDragStart(type)}
                onMouseOver={() => this.props.setContextualHelp(ADD_FM_SYNTH_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                onClick={() => this.onClickMultiSampler()}
                name="Sampled Instrument"
                />
             <InstrumentOption
               onDragStart={(type) => this.onDragStart(type)}
                type={MULTI_SYNTH}
                onMouseOver={() => this.props.setContextualHelp(ADD_MULTI_SYNTH_BUTTON)}
                onMouseLeave={() => this.props.setContextualHelp(undefined)}
                onClick={() => this.onClickMultiSynth()}
                name="Synth"/>
             <InstrumentOption
               onDragStart={(type) => this.onDragStart(type)}
                onMouseOver={() =>
                  this.props.setContextualHelp(ADD_EXTERNAL_INSTRUMENT_BUTTON)}
                onClick={() => this.onClickExternalInstrument()}
                onMouseLeave={() =>
                  this.props.setContextualHelp(undefined)}
                name="External Instrument"/>
             <InstrumentOption
               onDragStart={(type) => this.onDragStart(type)}
                onMouseOver={() =>
                  this.props.setContextualHelp(ADD_EXTERNAL_INSTRUMENT_BUTTON)}
                onClick={() => this.onClickInstrumentRack()}
                onMouseLeave={() =>
                  this.props.setContextualHelp(undefined)}
                name="Instrument Rack"/>
            </div>);
    }
}

class InstrumentOption extends Component {
    render() {
        return (
            <div
              draggable
              onDragOver={(e) => e.preventDefault()}
              onDragStart={() => this.props.onDragStart(this.props.type)}
              onMouseOver={this.props.onMouseOver}
              onMouseLeave={this.props.onMouseLeave}
              className="instrument-option">
              <span
                onClick={this.props.onClick}
                className="instrument-option-name">
                {this.props.name}
              </span>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setContextualHelp: (help) => dispatch(setContextualHelp(help)),
        setInstrumentTypeDragging: (type) => dispatch(setInstrumentTypeDragging(type))
    }
};
 
export default connect(null, mapDispatchToProps)(InstrumentsView);
